export function getDatasPadrao() {
    const fim = new Date();
    const ini = new Date();
    ini.setDate(ini.getDate() - 30);
    const fmt = (d) => {
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        return `${day}/${month}/${d.getFullYear()}`;
    };
    return { datInic: fmt(ini), datFina: fmt(fim) };
}
